import '../../styles/interactives.scss'
import { useCallback, useEffect, useRef } from 'react'
const threshold = [0.75, 0.85]

export default function JobAttainment() {
  const paragraphs = useRef(null)
  const interactive = useRef(null)

  const handleSteps = useCallback(
    (entries) => {
      entries.forEach((entry) => {
        // check that we have a ref, and that we are measuring one way only
        if (!interactive?.current || entry?.boundingClientRect.y < 0) return
        const ratio = entry?.intersectionRatio ?? 0

        // On Mount the observer get called with a 0 value
        if (ratio === 0) return

        const paragraph = Number(entry?.target.getAttribute('data-index') ?? 0)
        if (paragraph === 0) return

        const beforeP1 = paragraph === 1 && ratio < threshold[0]
        const afterP1 = paragraph === 1 && ratio > threshold[1]

        const beforeP2 = paragraph === 2 && ratio < threshold[0]
        const afterP2 = paragraph === 2 && ratio > threshold[1]

        if (beforeP1) {
          interactive.current.removeAttribute('data-step')
        } else if (afterP1 || beforeP2) {
          interactive.current.setAttribute('data-step', 90)
        } else if (afterP2) {
          interactive.current.setAttribute('data-step', 100)
        }
      })
    },
    [interactive]
  )

  useEffect(() => {
    const observer = new IntersectionObserver(handleSteps, { threshold })

    if (paragraphs?.current) {
      paragraphs.current.querySelectorAll('li').forEach((paragraph, index) => {
        paragraph.setAttribute('data-index', index + 1)
        observer.observe(paragraph)
      })
    }

    return () => observer.disconnect()
  }, [handleSteps, paragraphs])

  return (
    <section className="interactive" name="Job Attainment">
      <header>
        <h2>
          Exposure creates a higher likelihood of finding{' '}
          <strong>a great first job</strong>&nbsp;-&nbsp;as compared to other
          factors, like internships
        </h2>
      </header>
      <main>
        <aside>
          <figure ref={interactive} className="job-attainment">
            <div className="ja-tooltip" title="More Likely"></div>
            <div className="ja-scale"></div>
            <div className="ja-bar">
              <span title="Low Exposure"></span>
              <span title="High Exposure"></span>
            </div>
          </figure>
        </aside>
        <ul ref={paragraphs}>
          <li>
            <p>
              Those who report a high level of exposure to 3 or more industries
              are 90% or 1.9 times more likely to secure{' '}
              <strong>first round interviews</strong>
            </p>
          </li>
          <li>
            <p>
              They are also 100% or 2 times more likely to{' '}
              <strong>advance in processes</strong> after the first round
              interview
            </p>
          </li>
        </ul>
      </main>
    </section>
  )
}
